import { apiFetch } from "../client";

export function getSubscriptionPrices(ignorePlusDiscount = false) {
  const url = ignorePlusDiscount
    ? "/subscription/prices/?ignore_plus_discount=1"
    : "/subscription/prices/";
  return apiFetch(url, {
    method: "GET",
  });
}

export function getSubscriptionCouponDiscount({
  refs,
  package_id,
  forest_management_plan_id,
  coupon_code,
}) {
  return apiFetch("/subscription/coupon-discount/", {
    method: "POST",
    body: JSON.stringify({
      refs,
      package_id,
      forest_management_plan_id,
      coupon_code,
    }),
  });
}

export function getSubscriptionCheckout({ refs, properties, coupon_code, extra_data }) {
  return apiFetch("/subscription/checkout/", {
    method: "POST",
    // REMOVE 'refs' BEFORE MERGING
    body: JSON.stringify({ refs, properties, coupon_code, extra_data }),
  });
}